import { ElementInput } from './element';

export class ElementInputFileMultiUpload extends ElementInput {
  filePath: string;
  fileContext: string;

  constructor(
  ) {
    super();
    this.typeElement = 'file-multi-upload';
    this.filePath = '';
    this.fileContext = '';
  }
}


